export default {"src":"/login-app/[GIT_HASH]/_next/static/media/materialization_planned.789cd68b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};